<template>
  <div />
</template>

<script setup>
navigateTo('/', { redirectCode: 301 });
</script>
